import { useLocation, useNavigate } from "react-router-dom";
import { Home, LayoutGrid, Search, ShieldCheck } from "lucide-react";

const TABS = [
  { to: "/", label: "Каталог", icon: Home, test: "bottom-nav-home" },
  { to: "/collections", label: "Подборки", icon: LayoutGrid, test: "bottom-nav-collections" },
  { to: "/search", label: "Поиск", icon: Search, test: "bottom-nav-search" },
  { to: "/admin", label: "Админ", icon: ShieldCheck, test: "bottom-nav-admin" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] glass border-t border-white/10 z-50">
      <div className="flex items-center justify-around px-2 py-2 pb-[max(8px,env(safe-area-inset-bottom))]">
        {TABS.map((t) => {
          const active = t.to === "/" ? pathname === "/" : pathname.startsWith(t.to);
          const Icon = t.icon;
          return (
            <button
              key={t.to}
              data-testid={t.test}
              onClick={() => navigate(t.to)}
              className={`flex flex-col items-center gap-0.5 px-3 py-1 rounded-xl transition ${
                active ? "text-blue-400" : "text-slate-500"
              }`}
            >
              <Icon size={22} className={active ? "drop-shadow-[0_0_8px_rgba(0,122,255,0.6)]" : ""} />
              <span className="text-[10px] font-medium">{t.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
